export default "__VITE_ASSET__BoFOddqF__"